import { Injectable, NgZone } from '@angular/core';
import { ToastController } from '@ionic/angular';
import { CustomerdatabaseService } from './customerdatabase.service';
import { AuthService } from './auth.service';

@Injectable({ providedIn: 'root' })
export class CreditMonitorService {
  private unsubscribeCredits: any = null;
  private baselineCredits: number | null = null;
  private notified = new Set<number>();
  private thresholds = [50, 80, 90, 95, 100];

  constructor(
    private customerDB: CustomerdatabaseService,
    private toastCtrl: ToastController,
    private authService: AuthService,
    private ngZone: NgZone,
  ) {
    this.authService.isAuthenticated$.subscribe((isAuth) => {
      if (isAuth) {
        this.start();
      } else {
        this.stop();
      }
    });
  }

  private start() {
    if (this.unsubscribeCredits) return;
    const unsub = this.customerDB.retreiveUserCreditsAllTheTimeUpToDate((credits) => {
      this.ngZone.run(() => this.onCreditsUpdate(credits));
    });
    this.unsubscribeCredits = typeof unsub === 'function' ? unsub : null;
  }

  private stop() {
    if (this.unsubscribeCredits) {
      try { this.unsubscribeCredits(); } catch {}
      this.unsubscribeCredits = null;
    }
    this.baselineCredits = null;
    this.notified.clear();
  }

  private async onCreditsUpdate(currentCredits: number) {
    if (currentCredits == null || isNaN(currentCredits)) return;
    if (this.baselineCredits == null || currentCredits > this.baselineCredits) {
      this.baselineCredits = currentCredits;
      this.notified.clear();
    }
    if (!this.baselineCredits || this.baselineCredits <= 0) return;
    const used = Math.max(0, Math.min(100, Math.round(((this.baselineCredits - currentCredits) / this.baselineCredits) * 100)));
    for (const t of this.thresholds) {
      if (used >= t && !this.notified.has(t)) {
        this.notified.add(t);
        await this.presentThresholdToast(t);
      }
    }
  }

  private async presentThresholdToast(threshold: number) {
    const message = threshold >= 100
      ? 'You have reached 100% of your credits.'
      : `You have used ${threshold}% of your credits.`;
    const color = threshold >= 95 ? 'danger' : threshold >= 80 ? 'warning' : 'medium';
    const toast = await this.toastCtrl.create({
      message,
      duration: 4000,
      position: 'top',
      color,
    });
    await toast.present();
  }
}


